import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { getCoinSellerUniqueId } from "../../store/user/action";
import { createHost } from "../../store/user/action";
import male from "../../assets/images/male.png";
import useTranslation from "../../hooks/useTranslation";
import { T } from "../../util/theme";

const SUBMIT_GRAD = "linear-gradient(84.57deg, #FD297E 0%, #6B01FF 100%)";

function CoinSeller(props) {
  const { t } = useTranslation();
  const { dialog } = useSelector((state) => state.sellerCoin);
  const { userId } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [uniqueId, setUniqueId] = useState("");
  const [errors, setError] = useState({
    userId: "",
  });

  useEffect(() => {
    dispatch(getCoinSellerUniqueId(search));
  }, [search]);

  useEffect(() => {
    setData(userId);
  }, [userId]);

  useEffect(() => {
    if (search === "") {
      setData([]);
    }
  }, [search]);

  useEffect(() => {
    setError({
      userId: "",
    });
    setSearch("");
    setUniqueId("");
  }, [dialog]);

  const handleClose = () => {
    dispatch({ type: "CLOSE_COIN_SELLER_DIALOGUE" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!uniqueId) {
      setError({
        ...errors,
        userId: "Please select user",
      });
    } else {
      dispatch(createHost(localStorage.getItem("agencyId"), uniqueId));
      handleClose();
    }
  };

  const handleOptionClick = (item) => {
    setUniqueId(item.uniqueId);
    setSearch(item.uniqueId);
  };

  const handleSearchChange = (e) => {
    const newSearchValue = e.target.value;
    setSearch(newSearchValue);
    if (newSearchValue === "") {
      setUniqueId("");
      setSearch("");
      setData([]);
    }
  };

  return (
    <>
      <Dialog
        open={dialog}
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        elevation={0}
        style={{ zIndex: 9999999 }}
        hideBackdrop={false}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.75) !important",
            background: "rgba(0, 0, 0, 0.75) !important",
          },
        }}
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0.75) !important",
            background: "rgba(0, 0, 0, 0.75) !important",
          },
        }}
        PaperProps={{
          sx: {
            background: "#381559 !important",
            borderRadius: "12px !important",
            color: "#fff !important",
            overflow: "hidden !important",
            margin: "16px !important",
            maxWidth: "360px !important",
            width: "100%",
            boxShadow: "none !important",
          },
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            padding: "20px 48px 16px",
            borderBottom: "1px solid rgba(255,255,255,0.10)",
          }}
        >
          <p
            style={{
              color: "#FFFFFF",
              fontSize: 18,
              fontWeight: 600,
              margin: 0,
              textAlign: "center",
            }}
          >
            {t("add_host", "Add Host")}
          </p>
          <button
            type="button"
            onClick={handleClose}
            aria-label="Close"
            style={{
              position: "absolute",
              right: 14,
              top: "50%",
              transform: "translateY(-50%)",
              width: 35,
              height: 35,
              borderRadius: "50%",
              border: "none",
              background: "#FFFFFF1A",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              padding: 0,
              lineHeight: 0,
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="2.6"
              strokeLinecap="round"
              style={{ display: "block", flexShrink: 0 }}
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <DialogContent style={{ padding: "18px 20px 22px" }}>
          <form onSubmit={handleSubmit}>
            <label
              style={{
                display: "block",
                color: "#FFFFFF",
                fontSize: 16,
                fontWeight: 500,
                marginBottom: 10,
              }}
            >
              {t("user_id", "User ID")}
            </label>

            <input
              type="number"
              className="agency-add-host-input"
              placeholder={t("search_select_user_id", "Search User ID")}
              value={search || uniqueId}
              onChange={handleSearchChange}
              style={{
                backgroundColor: "#FFFFFF1A",
                // border: "0.5px solid #FFFFFF26",
                border: "none",
                padding: "14px 16px",
                borderRadius: 12,
                width: "100%",
                color: "#FFFFFF",
                fontSize: 16,
                fontWeight: 300,
                lineHeight: 1,
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            <div
              style={{
                maxHeight: 180,
                overflowY: "auto",
                marginTop: data?.length || (search && data.length === 0) ? 10 : 0,
              }}
            >
              {search && data.length === 0 ? (
                <div
                  style={{
                    padding: 12,
                    color: T.sub,
                    fontSize: 13,
                  }}
                >
                  <p style={{ margin: 0 }}>{t("user_does_not_found")}</p>
                </div>
              ) : (
                data.map((item) =>
                  item?.uniqueId ? (
                    <div
                      key={item.uniqueId}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "10px 4px",
                        borderBottom: `1px solid ${T.border}`,
                        cursor: "pointer",
                      }}
                      onClick={() => handleOptionClick(item)}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={item.image || male}
                          style={{
                            height: 30,
                            width: 30,
                            borderRadius: "50%",
                            marginRight: 10,
                            objectFit: "cover",
                          }}
                          alt="User"
                        />
                        <div>
                          <p
                            style={{
                              marginBottom: 0,
                              fontSize: 14,
                              color: "#fff",
                            }}
                          >
                            {item.uniqueId}
                          </p>
                          <span style={{ fontSize: 12, color: T.sub }}>
                            {t("ID")}: {item.uniqueId}
                          </span>
                        </div>
                      </div>
                      <input
                        type="radio"
                        name="radio-select"
                        checked={uniqueId === item.uniqueId}
                        onChange={() => setUniqueId(item.uniqueId)}
                        style={{
                          accentColor: "#40B405",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  ) : null,
                )
              )}
            </div>
            {errors?.userId && (
              <p className="text-danger mt-2" style={{ marginBottom: 0 }}>
                {errors?.userId}
              </p>
            )}
          </form>

          <button
            type="button"
            onClick={handleSubmit}
            style={{
              width: "100%",
              marginTop: 28,
              padding: "15px",
              border: "none",
              borderRadius: 999,
              background: "linear-gradient(84.57deg, #FD297E 0%, #6B01FF 100%)",
              color: "#FFFFFF",
              fontWeight: 600,
              lineHeight: 1,
              fontSize: 18,
              cursor: "pointer",
              opacity: uniqueId ? 1 : 0.9,
            }}
          >
            {t("submit", "Submit")}
          </button>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default CoinSeller;
